import { ConnectComponent } from '../../_components/ConnectComponent'
import { PreviousInsurancesPresenter } from './PreviousInsurances.presenter'
import { PreviousInsurancesView } from './PreviousInsurances.view'

export const PreviousInsurances = ConnectComponent(
  PreviousInsurancesView,
  PreviousInsurancesPresenter,
)
